var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('v-overlay',{attrs:{"value":_vm.loading,"opacity":"0.85","z-index":"1000"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"40"}})],1),_c('core-navigation-drawer'),_c('core-app-bar'),_c('v-main',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }